import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.store('publisher_id', 'Publisher', 'publishers')
      .multi(true),
    filter
      .options.store('offer_id', 'Offer', 'offers')
      .multi(true),
    filter
      .options.list('throttling', 'Throttling', THROTTLING_OPTIONS)
      .getValue(value => JSON.stringify(value))
      .setValue(value => JSON.parse(value)),
    filter
      .options.store('form_id', 'Form', 'forms')
      .multi(true),
    filter
      .options.list('cost_mode', 'Cost Mode', COST_MODE_OPTIONS)
      .multi(true),
    filter
      .options.list('payouttype', 'Payout Type', PAYOUT_OPTIONS)
      .multi(true),
    filter.boolean('active', 'Active'),
  ], [])
}

const THROTTLING_OPTIONS = [
  { label: 'Revenue Scrub: Global Settings', value: `{"throttling_method":"override"}` },
  { label: 'Revenue Scrub: Override', value: `{"throttling_method":"bucket"}` },
  { label: 'Manual Scrub', value: `{"throttling_method":{"$or":[null,"auto"]}}` },
]

const COST_MODE_OPTIONS = [
  { label: 'Static', value: 'static' },
  { label: 'Dynamic', value: 'dynamic' },
]

const PAYOUT_OPTIONS = [
  { label: 'CPC', value: 'cpc' },
  { label: 'CPA', value: 'cpa' },
  { label: 'CPM', value: 'cpm' },
  { label: 'CPL', value: 'cpl' },
  { label: 'Custom', value: 'custom' },
]
